import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../../common/global-constants";
import { BOItem } from "../../models/BOItem.model";
import { BOOdontologyBackgroundType } from "../../models/odo/BOOdontologyBackgroundType.model";

@Injectable({
  providedIn: 'root'
}

)
export class OdontologyBackgroundTypeService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/OdontologyBackgroundType';

    constructor(private http:HttpClient){}

    getAll():Observable<BOOdontologyBackgroundType[]>{
        return this.http.get<BOOdontologyBackgroundType[]>(this.myAppUrl + this.myApiUrl);
    }
}
